module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ciframe"
    }
  }, [_c('iframe', {
    attrs: {
      "id": "myiframe",
      "src": _vm.gurl
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-372ecbda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/ciframe.vue
// module id = 1010
// module chunks = 0